import { apiAuth, apiPublic } from "../config/api";

export async function getInventory(queryParams = '') {
    const url = queryParams ? `/api/inventory?${queryParams}` : '/api/inventory';
    return await apiAuth.fetch(url, {
        method: 'GET',
    });
}
export async function importInventory(data) {
    const url = `/api/dealer/import-vehicles`;
    return await apiAuth.fetch(url, {
        method: 'POST',
        body: data
    });
}

export async function getInventoryByMessageId(messageId, page = 1, limit = 10) {
    const url = `/api/inventory/search`;
    return await apiPublic.fetch(url, {
        method: 'POST',
        body: {
            messageId,
            page,
            limit,
            ...messageId
        }
    });
}